import { render } from "./Configs.vue?vue&type=template&id=166bfcae&scoped=true"
import script from "./Configs.vue?vue&type=script&lang=js"
export * from "./Configs.vue?vue&type=script&lang=js"

import "./Configs.vue?vue&type=style&index=0&id=166bfcae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166bfcae"]])

export default __exports__